import { IColumn } from "@fluentui/react";
import Constants from "../../core/libraries/Constants";
import { FeberApiClient } from "../../services/commonServices";
import { IAccountReport, ICancelRequest, IOrder } from "./types";
import _ from "lodash";
import { IFeberAPIResponse } from "../../services/type";


export const getExpiredOrders = async (isAdminMode: boolean = false) => {
    let response = await FeberApiClient.get("Order/GetOrderList", { params: { isAdminMode: isAdminMode, status: Constants.STATUS.EXPIRED } })
    return !!response.data && response.data.success && response.data.data;
}

export const getApprovedOrders = async (isAdminMode: boolean = false) => {
    let response = await FeberApiClient.get("Order/GetOrderList", { params: { isAdminMode: isAdminMode, status: Constants.STATUS.APPROVED } })
    return !!response.data && response.data.success && response.data.data;
}

export const getPendingUploads = async (isAdminMode: boolean = false) => {
    let response = await FeberApiClient.get("Report/GetReportListWithStatus", { params: { isAdminMode: isAdminMode, status: Constants.STATUS.PENDING } })
    return !!response.data && response.data.success && response.data.data;
}

export const getIncompleteUploads = async (isAdminMode: boolean = false) => {
    let response = await FeberApiClient.get("Report/GetReportListWithStatus", { params: { isAdminMode: isAdminMode, status: Constants.STATUS.DECLINED } })
    return !!response.data && response.data.success && response.data.data;
}

export const changeWorkflowIdPendingOrder = (order: IOrder, inputWorkflowId: string) => {
    return true;
}

export const getMyPendingOrders = async () => {
    let response = await FeberApiClient.get("Order/GetOrderList", { params: { status: Constants.STATUS.PENDING } })
    return !!response.data && response.data.success && response.data.data as IOrder;
}

export const getAllPendingOrders = async () => {
    let response = await FeberApiClient.get("Order/GetOrderList", { params: { isAdminMode: true, status: Constants.STATUS.PENDING } })
    return !!response.data && response.data.success && response.data.data as IOrder;
}

export const cancelWorkflow = async (request: ICancelRequest) => {
    let response = await FeberApiClient.post("WorkOn/CancelWorkflow", {
        ...request
    })
    return response.data.data
}

export const getMyApprovedReports = async () => {
    let response = await FeberApiClient.get("Report/GetReportListWithStatus", {
        params: {
            status: Constants.STATUS.PUBLISHED
        }
    })
    return !!response.data && response.data.success && response.data.data as IAccountReport;
}

export const updateWorkflowID = async (reportId: string, newWorkflowId: string) => {
    let response = await FeberApiClient.get("WorkOn/UpdateWorkflowID", {
        params: {
            reportId: reportId,
            workflowId: newWorkflowId
        }
    })
    return response.data as IFeberAPIResponse;
}

export const searchText = (cols: IColumn[], keyword: string, items: any[]) => {
    let results: any[] = [];
    if (keyword !== "") {
        items.forEach((item: any) => {
            let found: any = false;
            cols.forEach((col: any) => {
                if (col.name !== "" && col.fieldName !== "Action" && !_.isNil(item[col.fieldName])) {
                    if ((item[col.fieldName] as string).toLowerCase().indexOf(keyword.toLowerCase()) > -1) {
                        found = true;
                    }
                }
            });
            if (found === true) {
                results.push(item);
            }
        });
    }
    else {
        results = items;
    }
    return results;
}